import { Injectable } from '@angular/core';
import { generate } from './utils/template.util';
import { UUID } from './utils/util';

@Injectable({
  providedIn: 'root'
})
export class PluginGooglemapService {

  constructor(
  ) {

  }

  public exe(options:any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (options.method === 'addmarker') {
        const res = { 
          act: 'addmarker',
          targetobject: options.sourceobject,
          origin: options.origin,
          address: options.address,
          custom_data: options.custom_data,
          lat: options.lat,
          lng: options.lng,
          type: options.type,
          title: options.title,
          label: options.label,
          imageurl: options.imageurl,
          svg_code: options.svg_code,
          svg_fillcolor: options.svg_fillcolor,
          svg_fillopacity: options.svg_fillopacity,
          svg_strokeweight: options.svg_strokeweight,
          svg_rotation: options.svg_rotation,
          svg_scale: options.svg_scale
        };
        resolve([{ data: res }]);
      } else if (options.method === 'fitbounds') {
        const res = { 
          act: 'fitbounds',
          targetobject: options.sourceobject
        };
        resolve([{ data: res }]);
      } else if (options.method === 'removemarker') {
        const res = { 
          act: 'removemarker',
          targetobject: options.sourceobject,
          uuid: options.uuid
        };
        resolve([{ data: res }]);
      }
    })
  }

  public getTemplate(compName, options): any {
    return generate(options);
  }

}
